// src/stage2/Stage2Environment.jsx
import React, { Suspense, useCallback } from 'react';
import { PlaygroundScene } from './sceneExterior/PlaygroundScene.jsx';
import { ClassroomScene } from './sceneInterior/ClassroomScene.jsx'
import { DoorTrigger } from './sceneInterior/DoorTrigger.jsx'

export function Stage2Environment({
  variant = 'playground',
  setVariant,
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  castShadows = true,
  receiveShadows = true,
  onRingCollect,
  onRideStart,
  onBikeNearChange,
  bikesLiveRef
}) {

  return (
    <Suspense fallback={null}>
      {variant === 'playground' && (
        <>
          <PlaygroundScene
            position={position}
            rotation={rotation}
            scale={scale}
            castShadows={castShadows}
            receiveShadows={receiveShadows}
            onRideStart={onRideStart}
            onBikeNearChange={onBikeNearChange}
            onRingCollect={onRingCollect}
            bikesLiveRef={bikesLiveRef}
            />

            {/* door trigger OUTSIDE: when hit -> go classroom */}
          <DoorTrigger
            mode="enter"
            // debug
            radius={1.2}
            onTrigger={() => {
              console.log("[ENV] enter trigger fired. setVariant typeof:", typeof setVariant);
              setVariant?.("classroom");
              console.log("[ENV] requested variant -> classroom");
            }}
          />
        </>
      )}

      {variant === 'classroom' && (
        <>
          <ClassroomScene />

          {/* door trigger INSIDE: when hit -> go playground */}
          <DoorTrigger
            mode="exit"
            // debug
            onTrigger={() => {
            console.log("[ENV] exit trigger fired. setVariant typeof:", typeof setVariant);
            setVariant?.("playground");
            console.log("[ENV] requested variant -> playground");
          }}
          />
        </>
      )}

    </Suspense>
  );
}
